export default __webpack_public_path__ + "static/media/project-bloom-logo-dark.7d52c501.svg";